import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from './contexts/app';
import { QueryClientProvider } from 'react-query';
import queryClient from './lib/query-client';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ModalProvider } from './contexts/modal';
import RouteProvider from './router/provider';
import { initDatadog } from './lib/datadog';
import Environment from './lib/environment';
import ErrorBoundary from './components/error-boundary';
import { ThreadToastProvider } from './contexts/thread-toast';
import { UserSettingsProvider } from './contexts/user-settings';
import { MessageTrayProvider } from '@/contexts/message-tray';
import { EmitterProvider } from './contexts/emitter';
import { AppThemeProvider } from './contexts/app-theme';
import { SupportProvider } from './contexts/support';
import { FeatureProvider } from './contexts/feature';

initDatadog();
console.log(`build v${APP_VERSION}-${Environment.MODE}`);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ErrorBoundary>
          <AppProvider>
            <EmitterProvider>
              <QueryClientProvider client={queryClient}>
                <FeatureProvider>
                  <ModalProvider>
                    <SnackbarProvider>
                      <ThreadToastProvider>
                        <UserSettingsProvider>
                          <MessageTrayProvider>
                            <SupportProvider>
                              <RouteProvider />
                            </SupportProvider>
                          </MessageTrayProvider>
                        </UserSettingsProvider>
                      </ThreadToastProvider>
                    </SnackbarProvider>
                  </ModalProvider>
                </FeatureProvider>
              </QueryClientProvider>
            </EmitterProvider>
          </AppProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </AppThemeProvider>
  </React.StrictMode>
);
